module.exports = __webpack_public_path__ + "img/Hero@2x.d630c783.png";